<template>
   <div :class="`chat-box ${!showAds ? 'chat-box--no-ads' : ''}`">
      <div class="w-100 debug-info-wrapper" v-if="showingDebug">
         <div class="mt-2 bg-info text-white p-2">
            <div>
               List current URLs:
               <span class="text-warning">{{ urlSources }}</span>
            </div>
            <div>
               Playing URL:
               <span class="text-warning">{{ urlPlaying }}</span>
            </div>
            <div>
               Test URL (required)
               <b-input-group class="mt-3">
                  <b-form-input v-model="urlTesting" v-on:keyup.enter="startPlayVideo(urlTesting)" ref="urlTestingInput"></b-form-input>
               </b-input-group>
            </div>
            <div>
               Token:
               <b-input-group class="mt-3">
                  <b-form-input v-model="tokenTesting"></b-form-input>
                  <b-input-group-append>
                     <span class="ml-2">
                        JWT Token:
                        <SwitchCheckbox v-model="isJwtToken"></SwitchCheckbox>
                     </span>
                  </b-input-group-append>
               </b-input-group>
            </div>
            <div class="mt-3">
               Start testing URL:
               <b-button @click="startPlayVideo(urlTesting, tokenTesting, isJwtToken)" variant="danger" ref="button" :disabled="!urlTesting">
                  <b-icon-play-fill></b-icon-play-fill>
                  Play
               </b-button>
            </div>
         </div>
      </div>
      <div class="chat-box__admin-message-wrapper">
         <div
            :id="`admin-message-${index}`"
            class="chat-box__message chat-box__message--admin"
            :key="index"
            v-for="(adminMsg, index) in adminChannelMessages"
         >
            <span class="admin-message-wrapper__item__content" v-if="adminMsg.HasUrl" v-html="adminMsg.Message"></span>
            <span class="admin-message-wrapper__item__content" v-else>{{ adminMsg.Message }}</span>
         </div>
      </div>
      <div v-if="streamStatistic.enable_chat" class="chat-box__message-wrapper" id="list-messages-box" ref="messageDisplay">
         <div
            :id="`message-${index}`"
            :class="
               `chat-box__message ${
                  itemMsg.GuestId === ADMIN_ACC_DEFAULT.GuestId && itemMsg.DisplayName === ADMIN_ACC_DEFAULT.DISPLAY_NAME
                     ? 'chat-box__message--admin'
                     : (itemMsg.GuestId !== 0 && itemMsg.GuestId === user.guestId) || itemMsg.UserId === user.userInfo.userId
                     ? 'chat-box__message--your-own'
                     : ''
               } ${user.userInfo.type ? 'chat-box__message__admin-view' : ''}`
            "
            :key="index"
            :style="`opacity:${getOpacity(index)}`"
            v-for="(itemMsg, index) in listChannelMessages"
         >
            <span class="chat-box__message--content" v-if="itemMsg.HasUrl" v-html="itemMsg.Message"></span>
            <span class="chat-box__message--content" v-else>{{ itemMsg.Message }}</span>
            <span class="chat-box__message--delete" v-if="user.userInfo.type">
               <font-awesome-icon class="icon icon-delete" icon="trash-alt" @click="showConfirmDeleteModal(itemMsg)" />
            </span>
         </div>
      </div>
      <div v-if="streamStatistic.enable_chat" class="chat-box__input-wrapper">
         <b-form-textarea
            tabindex="-1"
            ref="chatInput"
            type="text"
            class="chat-box__input"
            placeholder="コメントする"
            v-model="stringInput"
            @keydown="keyDownPress"
            @keyup="keyUpPress"
            @update="updateInput"
            :key="indexChatInput"
         ></b-form-textarea>
         <b-img class="chat-box__icon" src="@/assets/media/icons/paper-plane.png" @click="sendMsg(stringInput)" />
      </div>
		<ConfirmModal :id="`${deleteModal.modalId}`" @confirmed="deleteMessage()" :title="deleteModal.title" :content="deleteModal.content" />
   </div>
</template>

<script>
import ChatBox from "../assets/js/components/chat-box";
export default ChatBox;
</script>

<style lang="scss">
@import "../assets/scss/components/chat-box";
</style>
